export default __webpack_public_path__ + "static/media/app.71b83d56.png";